import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CssBaseline } from '@mui/material';
import { CustomThemeProvider } from '../src/context/ThemeContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { InstallProvider } from './components/ui';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CustomThemeProvider>
    <CssBaseline />
    {/* Owns the add-to-home-screen offer. Above App so the sheet can appear
        over any route, and so the beforeinstallprompt listener is attached
        before the browser fires it. */}
    <InstallProvider>
      <App />
    </InstallProvider>
  </CustomThemeProvider>
);

// Makes the app installable and usable offline. Production builds only.
//
// By default a new service worker sits in "waiting" until every tab for the
// site is closed, which on a phone can be days — users would keep running an
// old build after a deploy. onUpdate promotes the new worker immediately and
// reloads once so the fresh assets are actually used.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (!registration.waiting) return;
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    // controllerchange fires once the promoted worker takes over. The guard
    // stops a reload loop if anything else swaps the controller later.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  },
});
